import { render, staticRenderFns } from "./HeadingBar.vue?vue&type=template&id=6628dd88"
import script from "./HeadingBar.vue?vue&type=script&lang=js"
export * from "./HeadingBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6628dd88')) {
      api.createRecord('6628dd88', component.options)
    } else {
      api.reload('6628dd88', component.options)
    }
    module.hot.accept("./HeadingBar.vue?vue&type=template&id=6628dd88", function () {
      api.rerender('6628dd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Commons/HeadingBar.vue"
export default component.exports